import { render } from "./profile-page.vue?vue&type=template&id=625156ac&scoped=true"
import script from "./profile-page.vue?vue&type=script&lang=js"
export * from "./profile-page.vue?vue&type=script&lang=js"

import "./profile-page.vue?vue&type=style&index=0&id=625156ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625156ac"]])

export default __exports__